<template>
  <div class="content">
    <el-row type="flex">
      <el-col :span="12">
        <h3>{{ form.remark }}</h3>
        <el-form
          label-position="top"
          :rules="rules"
          ref="form"
          label-width="80px"
          :model="form"
        >
          <!-- <el-form-item label="中文文档名称" prop="lang_list[1].title">
            <el-input
              v-model="form.lang_list[1].title"
              placeholder="请输入文档名称"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="中文文档内容" prop="lang_list[1].content">
            <tinymce
              :height="400"
              v-model="form.lang_list[1].content"
              :value="form.lang_list[1].content"
              ref="tinymce"
            />
          </el-form-item>
          <!-- <el-form-item label="英文文档名称" prop="lang_list[0].title">
            <el-input
              v-model="form.lang_list[0].title"
              placeholder="请输入文档名称"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="英文文档内容" prop="lang_list[0].content">
            <tinymce
              :height="400"
              v-model="form.lang_list[0].content"
              :value="form.lang_list[0].content"
              ref="tinymce"
            />
          </el-form-item>
          <el-form-item label="上传文件">
            <UploadDoc
              v-model="form.files"
              @uploaddoc="uploaddoc"
              ref="uploadDoc"
            ></UploadDoc>
          </el-form-item>
          <el-form-item>
            <el-row type="flex" justify="center">
              <el-button @click="back"> 返回 </el-button>
              <el-button type="primary" @click="store" :loading="btnLoading">
                保存
              </el-button>
            </el-row>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
import Tinymce from '@/components/Tinymce'
import UploadDoc from '@/components/UploadDoc/index.vue'
export default {
  components: { Tinymce, UploadDoc },
  data() {
    return {
      btnLoading: false,
      rules: {
        // 'lang_list[0].title': [
        //   {
        //     required: true,
        //     message: '该项不能为空，请输入',
        //     trigger: 'change',
        //   },
        // ],
        // 'lang_list[1].title': [
        //   {
        //     required: true,
        //     message: '该项不能为空，请输入',
        //     trigger: 'change',
        //   },
        // ],
      },
      form: {
        id: '',
        lang_list: [
          {
            lang: 'en_US',
            title: '',
            content: '',
          },
          {
            lang: 'zh-CN',
            title: '',
            content: '',
          },
        ],
      },
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id
      this.detail()
    }
  },
  methods: {
    uploaddoc(res) {
      console.log('uploaddoc', res)
    },
    back() {
      this.$router.back()
    },
    detail() {
      request({
        url: '/api/backend/doc/detail',
        method: 'get',
        params: {
          id: this.$route.query.id,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = {
            ...res.data,
            files: res.data.files || [],
          }
          // if (res.data.lang_list.length == 0) {
          //   this.form.lang_list = [
          //     {
          //       lang: 'en_US',
          //       title: '',
          //       content: '',
          //     },
          //     {
          //       lang: 'zh-CN',
          //       title: '',
          //       content: '',
          //     },
          //   ]
          // }
        }
      })
    },
    processFileUrls(fileList) {
      // 定义需要检查和移除的基础路径
      const basePath = process.env.VUE_APP_AWS_S3_DOMAIN
      // 遍历文件列表并处理每个元素
      return fileList.map((file) => {
        // 检查文件对象是否存在且包含 url 属性
        if (file && file.url) {
          // 判断 url 是否包含指定的基础路径
          if (file.url.includes(basePath)) {
            // 移除基础路径，只保留后面的部分
            const processedUrl = file.url.replace(basePath, '')
            // 返回更新后的对象（不修改原对象）
            return {
              ...file,
              url: processedUrl,
            }
          }
        }
        // 如果不包含指定路径或对象无效，返回原对象
        return file
      })
    },
    async store() {
      await this.$refs.uploadDoc.handleSubmit()
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          let imgPrefix = process.env.VUE_APP_AWS_S3_DOMAIN
          let prefixRegex = new RegExp(`^${imgPrefix}`)
          if (this.form.files?.length > 0) {
            this.form.files = this.processFileUrls(this.form.files)
          }

          request({
            url: '/api/backend/doc/store',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.$router.push({
                path: '/operation/doclist',
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
}
</style>
